import React from "react"
import { Label } from "../../../designSystem/Label";
import { ReferenceLinksPanel } from '../../../designSystem/compositeComponents/ReferenceLinksPanel';
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { CommentPanel } from "../../../designSystem/compositeComponents/CommentPanel";
import { ProtectedPageContext } from "../../_contexts/ProtectedPageContext";
import { ReferenceFilesPanel } from '../../../designSystem/compositeComponents/ReferenceFilesPanel';
import { UserToken } from "../../../amorg-common";
import { FileLinkCommentPageSection } from "../../../designSystem/compositeComponents/FileLinkCommentPageSection";
import { FileLinkCommentsButtonRow } from '../../../designSystem/compositeComponents/FileLinkCommentsButtonRow';


export const FileLinkCommentOverview = (): JSX.Element => 
{
    const activeUser = React.useContext(ProtectedPageContext).user as UserToken;

    const id = '123';

    return (
        <Flex flexDirection="column" gap={48}>

            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>FileLinkCommentsButtonRow</Label>                       
                <FileLinkCommentsButtonRow
                    fileReference={{ type: 'None', id: id }}
                    linkReference={{ type: 'None', id: id }}
                    commentReference={{ type: 'None', id: id }}
                />
            </div>

            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>FileLinkCommentPageSection</Label>                       
                <FileLinkCommentPageSection
                    fileReference={{ type: 'None', id: id }}
                    linkReference={{ type: 'None', id: id }}
                    commentReference={{ type: 'None', id: id }}
                />
            </div>
           
            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>CommentPanel</Label>                       
                <CommentPanel
                    commentReference={{ type: 'None', id: id }}
                    activeUser={activeUser}
                />
            </div>

            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>ReferenceLinksPanel</Label>                       
                <ReferenceLinksPanel
                    modalEditing
                    reference={{ type: 'None', id: id }}
                />
            </div>
            <div style={{border:' 1px solid black', padding:'20px', minHeight: '300px', display:'flex', flexDirection: 'column', justifyContent: 'stretch'}}>
                <Label>ReferenceFilesPanel</Label>                       
                <ReferenceFilesPanel
                    modalEditing
                    referenceType="None"
                    objectId={id}
                />
            </div>
  
        </Flex>
    )
}
